import { FunctionComponent } from 'react';
import { useSelector } from '@cbridge-utils/react-redux';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import { Notification } from '../Notification/Notification';
import { notificationsPropsSelector } from './Notifications.selector';

const NotificationsStack = styled(Stack)({
  position: 'fixed',
  bottom: 16,
  right: 16,
  zIndex: 9999,
});

export const Notifications: FunctionComponent = () => {
  const { notifications } = useSelector(notificationsPropsSelector);

  if (notifications.length === 0) {
    return null;
  }

  return (
    <NotificationsStack spacing={1}>
      {notifications.map((notification) => (
        <Notification key={notification.notificationKey} {...notification} />
      ))}
    </NotificationsStack>
  );
};
